import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import "./styles.css";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const duvidas = [
  {
    pergunta: "Quando o dash atualiza?",
    resposta:
      "O painel atualiza a cada 10min todos os dias. Caso em algum momento ocorra algum erro, haverá um aviso no seu dashboard.",
  },
  {
    pergunta: "A receita em real é o valor final que vou receber?",
    resposta:
      "Não. O valor em real que aparece é só uma estimativa. Ele depende da cotação do dólar, que pode mudar até o dia do pagamento. Então o valor final pode ser um pouco maior ou menor.",
  },
  {
    pergunta:
      "Todos os valores que aparecem pra mim são os mesmos que irei receber?",
    resposta:
      "Não. Os valores que você vê no dia a dia são apenas uma estimativa. Eles servem pra você ter uma noção de quanto vai receber. Mas o valor certo mesmo só vem quando o financeiro manda o relatório pedindo a nota fiscal. Esse sim é o valor oficial.",
  },
  {
    pergunta: "Como funciona o pagamento?",
    resposta:
      "Vamos imaginar que você gerou receita no mês de junho. O Google faz o pagamento no dia 23 de julho. Depois disso, o valor é repassado para você em agosto. Porém, se você emitir sua nota fiscal até o dia 01/08 as 16h você receberá no mesmo dia, agora se você emitir entre o dia 02 e o dia 11/08 você receberá apenas no dia 12/08.",
  },
  {
    pergunta: "Posso receber sem emitir nota fiscal?",
    resposta:
      "Não pode. A nota fiscal é obrigatória para que o pagamento seja feito. É o que garante que está tudo certo com a lei.",
  },
  {
    pergunta: "Posso emitir a nota fiscal com o CNPJ de outra pessoa?",
    resposta:
      "Pode sim, desde que o CNPJ usado seja da mesma pessoa que vai receber o dinheiro na conta bancária.",
  },
  {
    pergunta: "Preciso postar em todas as redes que me deram o link?",
    resposta:
      "Não precisa. As redes que aparecem são as mais comuns, mas você escolhe em quais quer postar. Só lembre que, quanto mais redes você usar, mais chances tem de alcançar um bom resultado.",
  },
  {
    pergunta: "Como posso usar os vídeos para cortes?",
    resposta:
      "Fica a seu critério. Você pode usar os vídeos do jeito que achar melhor, desde que respeite o que está escrito no contrato.",
  },
  {
    pergunta: "O que é RPM?",
    resposta:
      'RPM quer dizer "Receita por Mil". É uma estimativa em dólar de quanto sua página está rendendo a cada mil acessos. Esse valor pode mudar dependendo da quantidade de anúncios, dos cliques e de outros fatores. Não é um valor fixo, é só pra você ter uma ideia de como está indo.',
  },
];

function Duvidas() {
  const [ativo, setAtivo] = useState(null);

  const toggle = (index) => {
    setAtivo(ativo === index ? null : index);
  };

  return (
    <div className="wrapper">
      <div className="duvidasFrequentes">
        <div className="logoDuvidas">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>
        <h2 className="tituloDuvidas">Dúvidas Frequentes</h2>
        <div className="accordion">
          {duvidas.map((item, index) => (
            <div
              className={`accordionItem ${ativo === index ? "ativo" : ""}`}
              key={index}
            >
              <button
                className={`accordionTitle ${ativo === index ? "ativo" : ""}`}
                onClick={() => toggle(index)}
              >
                {item.pergunta}
                <span className="arrow">
                  {ativo === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
                </span>
              </button>
              <div className="accordionContent">
                <p>{item.resposta}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Duvidas;
